import { dm_loai_lien_he } from "../../../models/response/category/dm_loai_lien_he";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const objDmLoaiLienHeDefine = {
    LOAD_START: 0,
    LOAD_SUCCESS: [] as dm_loai_lien_he[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as dm_loai_lien_he | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as dm_loai_lien_he,
    SAVE_SUCESS: {} as dm_loai_lien_he,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eDmLoaiLienHeActionTypeIds = generateActionTypeIds(objDmLoaiLienHeDefine, "DM_LOAI_LIEN_HE")
export type IDmLoaiLienHeActionTypes = IGenericActionType<typeof objDmLoaiLienHeDefine, "DM_LOAI_LIEN_HE">
